var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-pweb',[_c('h2',[_vm._v("Exportação de arrematantes")]),_c('p',[_vm._v("Exporte a base de dados de arrematantes para uso em mailing ou outros sistemas")]),_c('div',{staticClass:"m-t-lg"},[_vm._v(" Exportação indisponível no momento. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }